import React, { useState } from 'react';
import styles from '../assets/info-panel.module.scss';
import classNames from 'classnames';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faInfo } from '@fortawesome/free-solid-svg-icons';
import { Button, Modal } from 'react-bootstrap';

const InfoPanel: React.FunctionComponent = () => {
    //const dispatch = useDispatch();
    const [opened, setOpened] = useState(false);
    const [openedTab, setOpenedTab] = useState(0);
    const handleClose = () => {
        setOpened(false);
    };
    return (
        <div>
            <button
                className={classNames(styles.infoPanelWrap, 'btn  btn-add-info')}
                type="button"
                onClick={() => setOpened(true)}
            >
                <FontAwesomeIcon icon={faInfo} />
            </button>
            <Modal show={opened} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Instruction</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ul className={classNames(styles.wrapInfoBlock)}>
                        <li>
                            <b
                                className="btn btn-outline-secondary mb-1 w-100"
                                style={{ cursor: 'pointer', fontWeight: 'bold', fontSize: 16 }}
                                onClick={() => setOpenedTab(1)}
                            >
                                To schedule a session on the calendar tab:
                            </b>
                            <div
                                style={{
                                    background: 'rgb(241 240 240)',
                                    border: '1px solid #d1d1d1',
                                    padding: 5,
                                    marginTop: '-6px',
                                    marginBottom: '8px',
                                }}
                                className={`${openedTab === 1 ? '' : 'd-none'}`}
                            >
                                <ol className={'pl-4'}>
                                    <li>Click on the left side of the mouse in the calendar area;</li>
                                    <li>
                                        <span>Select a student, start and end time in the pop-up</span>
                                        &nbsp;(put your attention to the name, case number, service type and location as
                                        long as you can work with the same student, but this student can have two
                                        different service types);&nbsp;
                                    </li>
                                    <li>
                                        <span>
                                            A<strong>&nbsp;weekly option</strong>
                                        </span>
                                        <span>
                                            <strong>&nbsp;</strong>means that this session will be repeated at the same
                                            time every week for this particular month. Next month a new weekly schedule
                                            should be set up. Weekly sessions will be marked;
                                        </span>
                                    </li>
                                    <li>
                                        <span>Click on the "</span>
                                        <span>Create"</span>
                                        <span>&nbsp;button.</span>
                                    </li>
                                </ol>
                            </div>
                        </li>
                        <li>
                            <b
                                className="btn btn-outline-secondary mb-1 w-100"
                                style={{ cursor: 'pointer', fontWeight: 'bold', fontSize: 16 }}
                                onClick={() => setOpenedTab(2)}
                            >
                                To edit the session on the calendar tab:
                            </b>
                            <div
                                style={{
                                    background: 'rgb(241 240 240)',
                                    marginTop: '-6px',
                                    border: '1px solid #d1d1d1',
                                    marginBottom: '8px',
                                    padding: 5,
                                }}
                                className={`${openedTab === 2 ? '' : 'd-none'}`}
                            >
                                <ol className={'pl-4'}>
                                    <li>
                                        <span>Click on the session; </span>
                                    </li>
                                    <li>Change the session time and/or date in the pop-up;</li>
                                    <li>Click on “Update” button;&nbsp;</li>
                                    <li>
                                        Clicking on&nbsp;“Update weekly” button means updating all weekly sessions for
                                        this month with the same change too.
                                    </li>
                                </ol>
                            </div>
                        </li>
                        <li>
                            <b
                                className="btn btn-outline-secondary mb-1 w-100"
                                style={{ cursor: 'pointer', fontWeight: 'bold', fontSize: 16 }}
                                onClick={() => setOpenedTab(3)}
                            >
                                To confirm the session from the calendar tab:
                            </b>
                            <div
                                style={{
                                    background: 'rgb(241 240 240)',
                                    marginTop: '-6px',
                                    marginBottom: '8px',
                                    border: '1px solid #d1d1d1',
                                    padding: 5,
                                }}
                                className={`${openedTab === 3 ? '' : 'd-none'}`}
                            >
                                <ol className={'pl-4'}>
                                    <li>Click on your session on the calendar;</li>
                                    <li>Click on the blue button “Note”;</li>
                                    <li>
                                        <span>
                                            It will redirect to the session note document. Fill out all the required
                                            fields and/or add&nbsp;
                                        </span>
                                        files;
                                    </li>
                                    <li>Click on “Save” button;</li>
                                    <li>Click on "Sign" button;</li>
                                    <li>
                                        Click on “Yes” in the following pop-up: Are you sure you want to sign the note?;
                                    </li>
                                    <li>
                                        After this the session will change the status to confirmed automatically and
                                        will be highlighted with green colour on the calendar.
                                    </li>
                                </ol>
                                <b>
                                    The session gets a confirmed status automatically after signing only in the case
                                    when the provider has all previous confirmed sessions.{' '}
                                </b>
                            </div>
                        </li>
                    </ul>
                </Modal.Body>
                <Modal.Footer className={'text-center d-flex justify-content-center'}>
                    <Button className={classNames(styles.btnDone, 'btn btn-info')} variant="info" onClick={handleClose}>
                        Got it
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default InfoPanel;
